"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Expectations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="7114" id="what-to-expect-after-you-reach-out" className="bg-background text-foreground py-44 md:py-60 px-6 md:px-24">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-12 gap-4 md:gap-8">
          <div ref={ref} className={`col-span-12 md:col-span-8 md:col-start-3 transition-all duration-[1100ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <p className="font-default italic text-secondary mb-16 !text-3xl" style={{
            letterSpacing: "0.005em"
          }}>After You Reach Out</p>

            <h2 className="font-default font-semibold text-foreground" style={{
            fontSize: "clamp(2.25rem, 4vw, 3.75rem)",
            lineHeight: 1.1,
            letterSpacing: "-0.015em"
          }}>What Happens After You Request a Quote</h2>

            <div className="mt-16 space-y-8 font-default font-normal text-foreground" style={{
            fontSize: "clamp(1.375rem, 2vw, 1.875rem)",
            lineHeight: 1.5,
            letterSpacing: "-0.005em"
          }}>
              <p><div data-ast-id="f:/src/pages/Contact/sections/Expectations.tsx|sig:5lgikr" data-ast-start="1445" data-ast-end="1462"><b className="">Submit the form</b> to request a free bathroom remodel quote in Lakeland, FL and nearby Polk County areas.<div data-ast-id="f:/src/pages/Contact/sections/Expectations.tsx|sig:5ku5al" data-ast-start="1586" data-ast-end="1603"><br /></div><div data-ast-id="f:/src/pages/Contact/sections/Expectations.tsx|sig:5kfiti" data-ast-start="1603" data-ast-end="1873">After you reach out, we’ll review your request and contact you about your bathroom remodel. You can share what you’re looking for, ask questions, and review next steps for your bathroom update, shower, tub, tile, flooring, vanity, fixtures, or layout changes.</div><div data-ast-id="f:/src/pages/Contact/sections/Expectations.tsx|sig:5j7gq2" data-ast-start="1873" data-ast-end="1890"><br /></div></div></p>
              
              
            </div>

            <p className="mt-16 font-default italic text-muted-foreground" style={{
            fontSize: "clamp(0.75rem, 0.85vw, 0.8125rem)",
            letterSpacing: "0.005em",
            lineHeight: 1.4
          }}>Serving Lakeland, FL and nearby Polk County areas</p>
          </div>
        </div>
      </div>
    </section>;
}